let timasColor = {
  black: "#252525",
  blackLight: "#CCCCCC",
  grey: "#666666",
  white: "#FDFDFD",
  white1: "#F2F2F2",
  white2: "#E4E4E4",
  primary: {
    main: "#BE171E",
    dark: "#8D0107",
    1: "#620000",
    2: "#851015",
    3: "#E5A2A5",
    4: "#F9E8E9"
  },
  secondary: {
    main: "#127F0A",
    dark: "#054609",
    1: "#0D5907",
    2: "#59A554",
    3: "#A0CC9D",
    4: "#E7F2E7"
  }
};

timasColor = {
  ...timasColor,
  blackGradient: `linear-gradient(90deg, #4B4B4B, #00000000)`,
  primary: {
    ...timasColor.primary,
    gradient: (color1, color2, deg) =>
      `linear-gradient(${deg || 270}deg,${
        color1 ? timasColor.primary[color1] : timasColor.primary.main
      },${color2 ? timasColor.primary[color2] : timasColor.primary[2]})`
  },
  secondary: {
    ...timasColor.secondary,
    gradient: (color1, color2, deg) =>
      `linear-gradient(${deg || 270}deg,${
        color1 ? timasColor.secondary[color1] : timasColor.secondary.main
      },${color2 ? timasColor.secondary[color2] : timasColor.secondary[1]})`
  }
};

export default timasColor;
